"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // Цвета текста

var colorMain = "#2D3033";
var colorGray = "#85878A";
var colorDarkGray = "#31746C";
var backgroundMain = "#fff";
var backgroundDark = "#262626";
var backgroundBlue = "#FBFBFB";
var breakpointXL = "1200px";
var breakpointLG = "1024px";
var breakpointMD = "768px";
var breakpointSM = "576px";
var breakpointXS = "400px";
var _default = {
  colorMain: colorMain,
  colorGray: colorGray,
  colorDarkGray: colorDarkGray,
  backgroundMain: backgroundMain,
  backgroundDark: backgroundDark,
  backgroundBlue: backgroundBlue,
  breakpointXL: breakpointXL,
  breakpointLG: breakpointLG,
  breakpointMD: breakpointMD,
  breakpointSM: breakpointSM,
  breakpointXS: breakpointXS
};
exports.default = _default;